import { makeStyles } from '@material-ui/core/styles';
import { theme } from '../styles/theme';

const useStyles = makeStyles({
  scrollButtons: {
    width: '24px'
  },
  flexContainer: {
    '& > *': {
      margin: '0 12px'
    },
    '& > *:focus': {
      color: theme.color.text.B5
    },
    '& > :first-child': {
      marginLeft: 0
    },
    '& > :last-child': {
      marginRight: 0
    }
  }
});

export default useStyles;
